export class CustomerAssignment {
  _id: string
  name: string
  constructor(assignment: CustomerAssignment) {
    const errors = []

    if (!assignment._id) {
      errors.push('_id')
    }

    if (!assignment.name) {
      errors.push('name')
    }

    if (errors.length > 0) {
      throw JSON.stringify(errors)
    }

    this._id = assignment._id
    this.name = assignment.name
  }
}
